// extracted by mini-css-extract-plugin
module.exports = {"coinIcon":"styles_coinIcon__7WZ05","earnContainer":"styles_earnContainer__VDBKY"};